// extracted by mini-css-extract-plugin
export default {"block":"zk","flex":"Ak","radio":"Bk","label":"Ck","error":"Dk","extra":"Ek"};